import { useQuery } from "@tanstack/react-query";
import { Tooltip } from "antd";
import CustomDateFilter from "common/components/CustomDateFilter";
import SearchComponent from "common/components/SearchComponent";
import {
  StyledAntdTable,
  StyledButton
} from "common/components/StyledElements";
import APIConstants from "common/constants/APIConstants";
import { useAuthContext } from "common/contexts/AuthContext";
import { formatQuery } from "common/utils";
import { api } from "common/utils/APIMethods";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";


const MainContainer = styled.div`
  margin: 20px auto 0;
  width: 98%;
`;

const HeaderContainer = styled.div`
  display: flex;
  column-gap: 16px;
  margin-bottom: 16px;
  height: 56px;
  @media screen and (max-width: 1279px) {
    height: fit-content;
    flex-wrap: wrap;
    row-gap: 8px;
    margin-bottom: 10px;
  }
`;

const RightContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const AddStyledButton = styled(StyledButton)`
  padding: 12px;
`;


const TypeDiv = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor || "white"};
`;

const getUrlWithOrderStatusIds = (startDate, endDate, queryParams) => {
  let paramString = null;
  const params = new URLSearchParams(queryParams);
  if (endDate) {
    params.append("endDate", endDate);
  }
  if (startDate) {
    params.append("startDate", startDate);
  }
  paramString = params.toString();

  const baseUrl = APIConstants.getAllPurchaseOrders;

  return paramString ? `${baseUrl}?${paramString}` : baseUrl;
};

const AllSaleList = () => {
  const { authConfig } = useAuthContext();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 20
  });
  const [selectedDates, setSelectedDates] = useState([
    dayjs().subtract(7, "days").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD")
  ]);

  const navigate = useNavigate();

  const {
    data: saleList = [],
    isLoading: isSaleListLoading
  } = useQuery({
    queryKey: [
      "saleList",
      searchText,
      pagination.currentPage,
      pagination.pageSize,
      selectedDates
    ],
    queryFn: () =>
      api(
        {
          url: getUrlWithOrderStatusIds(selectedDates[0], selectedDates[1], {
            query: formatQuery(searchText)
          })
        },
        authConfig
      )
  });

  const typeColorMapping =useMemo(()=>{
    const typeColor = {
    IN_TRANSIT: { background: "#c9b3e2ff" },
    YET_TO_BE_DISPATCHED: { background: "#4ecdc4" },
    DELIVERED: { background: "#ffd97d" }
   };
   return typeColor;
  },[]);

  const SaleColumns = useMemo(() => {
   
    const memoColumns = [
      {
        title: "PO Number",
        render: (item) => item?.poNumber,
        width: "10%"
      },
      {
        title: "CAS Number",
        render: (item) => item?.casNumber,
        width: "10%"
      },
      {
        title: "Material Code",
        render : (item) => item?.materialCode,
        width : "10%"
      },
      {
        title : "Material Name",
        render : (item) => item?.materialName,
        width : "10%"
      },
      {
        title: "Vendor Name",
        render: (item) => item?.vendorName,
        width: "10%"
      },
      {
        title: "Quantity",
        render: (item) => item?.quantity,
        width: "10%"
      },
      {
        title: "Total",
        render: (item) => item?.total,
        width: "10%"
      },
       {
        title: "Status",
        render: (item) => (
          <TypeDiv
            backgroundColor={
              typeColorMapping[item?.scmPoStatus?.status]?.background
            }
          >
            <span>{item?.scmPoStatus?.status.replaceAll("_", " ")}</span>
          </TypeDiv>
        ),
        width: "10%"
      }
    ].filter(Boolean);
    return memoColumns;
  },[typeColorMapping]);

  return (
    <MainContainer>
      <HeaderContainer>
        <SearchComponent
          placeholder="Search by Product Name or PO Number"
          searchText={searchText}
          setSearchText={setSearchText}
          pagination={pagination}
          setPagination={setPagination}
        />
        <RightContainer>
          <CustomDateFilter
            pagination={pagination}
            setPagination={setPagination}
            selectedDates={selectedDates}
            setSelectedDates={(data) => {
              setSelectedDates(data);
            }}
          />
          <Tooltip
            title="Select Location"
            trigger={["hover"]}
            color="rgba(0, 0, 0, 0.70)"
            styles={{
              body: {
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
                fontFamily: "Poppins"
              },
              root: {
                borderRadius: "12px"
              }
            }}
            placement="topLeft"
          >
            {/* <CustomSelect
              menuTitle={t("filter location")}
              isLoading={isLocationsLoading}
              filterData={filteredLocations}
              selectedOption={selectedLocations}
              setSelectedOption={(data) => {
                setSelectedLocations(data);
              }}
              type="Locations"
              setPagination={setPagination}
              pagination={pagination}
              isMultiSelect
              containerStyle={{ width: 183 }}
              defaultStatuses={inventoryLocations?.map((item) => item.id)}
            /> */}
          </Tooltip>
          <AddStyledButton
            type="primary"
            onClick={() => navigate("add")}
          >
            Add PO
          </AddStyledButton>
        </RightContainer>
      </HeaderContainer>
      <StyledAntdTable
        columns={SaleColumns}
        isLoading={isSaleListLoading}
        dataSource={saleList || []}
        pagination={{
          current: pagination.currentPage + 1,
          pageSize: pagination.pageSize,
          position: ["none", "none"]
        }}
        onRow = {(order)=>({
          onClick : ()=>{
            navigate(`details/${order.id}`,{state : order})
          }
        })}
      />
      {/* <PaginationComponent
        pagination={pagination}
        setPagination={setPagination}
        totalElements={saleList?.totalElements}
        totalPages={Math.ceil(
          (saleList?.totalElements ?? 0) / pagination.pageSize
        )}
        heading="products"
      />{" "} */}
    </MainContainer>
  );
};

export default AllSaleList;